import type { RequestPayload } from "@inertiajs/core";
import { Anchor, Button, Checkbox, Flex, Paper, Stack } from "@mantine/core";
import { useForm } from "@mantine/form";
import { terms_of_uses_path } from "../../routes";

type TermsOfUseFormProps = {
  onSubmit: (values: RequestPayload) => void;
};

export function TermsOfUseForm({ onSubmit }: TermsOfUseFormProps) {
  const form = useForm({
    mode: "uncontrolled",
    initialValues: {
      accept: false,
    },
  });
  const checkboxLabel = (
    <>
      Mit dem Ankreuzen dieses Kästchens erklären Sie sich mit unseren{" "}
      <Anchor href={terms_of_uses_path()} target="_blank">
        Nutzungsbedingungen
      </Anchor>{" "}
      einverstanden.
    </>
  );
  return (
    <Flex justify="center" align="center" pt="lg">
      <form onSubmit={form.onSubmit(onSubmit)}>
        <Paper shadow="sm" p="lg" withBorder w="40rem" maw="40rem">
          <Stack>
            <Checkbox label={checkboxLabel} key={form.key("accept")} {...form.getInputProps("accept", { type: "checkbox" })} />
            <Button type="submit" disabled={!form.getValues().accept}>
              Senden
            </Button>
          </Stack>
        </Paper>
      </form>
    </Flex>
  );
}
